// eslint-disable-next-line no-restricted-syntax
export const DOUBLE_BORDER_COLOR = "#B49DE6";

// eslint-disable-next-line no-restricted-syntax
export const DOUBLE_GRADIENT =
  "radial-gradient(86.48% 85.31% at 3.47% 14.69%, #E0D4F7 0%, #D1C1F0 52.23%, #B49DE6 100%)";

// eslint-disable-next-line no-restricted-syntax
export const DOUBLE_FOOTER_BACKGROUND_COLOR = "#F0EAFC";

// eslint-disable-next-line no-restricted-syntax
export const DOUBLE_FOOTER_TEXT_COLOR = "#7C5CBF";
